<template>
  <qx-card-form title="维修信息" v-show="showComponent">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    >
    </qx-custom-form>
    <button @click="getDataTest" class="test-btn">测试提交参数</button>
  </qx-card-form>
</template>
<script>
export default {
  data () {
    return {
      showComponent: false,
      baseForm: {
        isRepairCompleteOptions: [],
        form: [
          { label: '维修服务商', value: 'repairServiceName', type: 'input', disabled: false },
          { label: '维修地点', value: 'repairServiceAddress', type: 'input', disabled: false },
          { label: '联系方式', value: 'repairServiceTel', type: 'input', disabled: false },
          { label: '维修金额（元）', value: 'repairServiceAmt', type: 'input', disabled: false, placeholder: '输入金额(元)' },
          { label: '是否完结', value: 'isRepairComplete', type: 'select', default: '-1', disabled: false },
          {
            label: '维修清单',
            // vehicleAccidentRepairPicFileIds
            value: 'vehicleAccidentRepairPicFileList',
            type: 'img',
            accept: 'image/*',
            fileSize: 51200000000,
            attr: {
              limit: 5,
            },
            default: [],
            disabled: false,
          },
          {
            label: '完结图片',
            // vehicleAccidentRepairCompPicFileIds
            value: 'vehicleAccidentRepairCompPicFileList',
            type: 'img',
            accept: 'image/*',
            fileSize: 51200000000,
            attr: {
              limit: 5,
            },
            default: [],
            disabled: false,
          },
        ],
        rules: {
          repairServiceName: [
            { required: true, message: '请输入维修服务商', trigger: 'blur' },
          ],
          repairServiceAddress: [
            { required: true, message: '请输入维修地点', trigger: 'blur' },
          ],
          repairServiceTel: [
            { required: true, message: '请输入联系方式', trigger: 'blur' },
          ],
          repairServiceAmt: [
            { required: true, message: '请输入维修金额', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    async getDataTest () {
      this.sub();
    },
    setList (optionList) {
      this.baseForm.isRepairCompleteOptions = optionList;
    },
    initSelect (data, selectFieldName) {
      if (data[selectFieldName] !== undefined) {
        data[selectFieldName] = String(data[selectFieldName]);
      }
    },
    // 初始化图片列表数据
    initImgList (initData, imgListFieldName) {
      if (initData[imgListFieldName] && initData[imgListFieldName].length) {
        for (let item of initData[imgListFieldName]) {
          item.id = item.fileId;
          item.url = item.fileUrl;
        }
      }
    },
    // 提交/缓存图片列表数据
    subImgList (formData, imgListFieldName, fildIdsName) {
      if (formData[imgListFieldName] && formData[imgListFieldName].length) {
        let picFileIds = [];
        for (let item of formData[imgListFieldName]) {
          item.fileId = item.id;
          item.fileUrl = item.url;
          picFileIds.push(item.fileId);
        }
        formData[fildIdsName] = picFileIds.join();
      }
    },
    // 显示和禁用逻辑
    showAndDisabledLogic (data) {
      this.showComponent = false;
      let formItemDisabled = false;
      let endEdit = false;
      let formItemDisabledNames = ['repairServiceName', 'repairServiceAddress', 'repairServiceTel', 'repairServiceAmt'];

      if (data.accidentState > 2 && data.maintailState === 1) {
        this.showComponent = true;
      }

      let accidentRegisterState = `${data.accidentState}`;
      if (this.$route.query.accidentRegisterState) {
        accidentRegisterState = `${this.$route.query.accidentRegisterState}`;
      }

      // 重置一下所有选项
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'disabled',
        value: false,
      });

      switch (accidentRegisterState) {
        case '1':
          // 事故登记
          break;
        case '2':
          // 定损登记
          break;
        case '3':
          // 维修登记
          this.showComponent = true;
          if (data.busiCode !== undefined && data.busiCode !== '' && data.busiCode !== null && !this.$route.query.accidentRegisterState) {
            // 管理车辆费用
            // 只能修改图片 和是否完结
            formItemDisabled = true;
            endEdit = false;
          }
          break;
        case '4':
          // 理赔登记
          formItemDisabled = true;
          endEdit = true;
          formItemDisabledNames.push('vehicleAccidentRepairPicFileList', 'vehicleAccidentRepairCompPicFileList');
          break;
        default:
          break;
      }
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'disabled',
        value: formItemDisabled,
        names: formItemDisabledNames,
      });
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'disabled',
        value: endEdit,
        names: ['isRepairComplete'],
      });
      for (let name in this.baseForm.rules) {
        if (this.baseForm.rules[name]) {
          const rules = this.baseForm.rules[name];
          for (let item of rules) {
            // 如果组件不显示，则需要将必填项改为非必填，否则无法保存提交（因为会校验）
            item.required = this.showComponent;
          }
        }
      }
    },
    async handleSubData (cache) {
      let formData = null;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        // 这里处理的格式必须和详情接口返回的一样
        this.subImgList(formData, 'vehicleAccidentRepairPicFileList', 'vehicleAccidentRepairPicFileIds');
        this.subImgList(formData, 'vehicleAccidentRepairCompPicFileList', 'vehicleAccidentRepairCompPicFileIds');
      }
      return formData;
    },
    async cacheData () {
      const formData = await this.handleSubData(true);
      return formData;
    },
    async sub () {
      const formData = await this.handleSubData();
      if (formData) {
        delete formData.vehicleAccidentRepairPicFileList;
        delete formData.vehicleAccidentRepairCompPicFileList;
      }
      // console.log('提交参数', formData);
      return formData;
    },
    init (data = {}) {
      this.$refs.baseForm.reset();
      // 这里处理接口或者缓存返回的数据
      this.showAndDisabledLogic(data);
      this.initSelect(data, 'isRepairComplete');
      this.initImgList(data, 'vehicleAccidentRepairPicFileList');
      this.initImgList(data, 'vehicleAccidentRepairCompPicFileList');
      this.$refs.baseForm.setVal(data);
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
